<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="293.399"
    height="70.666"
    viewBox="0 0 293.399 70.666"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rechteck_49"
          data-name="Rechteck 49"
          width="293.399"
          height="70.666"
          fill="#fff"
        />
      </clipPath>
    </defs>
    <g id="Gruppe_1" data-name="Gruppe 1" clip-path="url(#clip-path)">
      <path
        id="Pfad_1"
        data-name="Pfad 1"
        d="M73.328,26.053c0-11.249,4.937-20.231,15.86-20.231s15.7,8.982,15.7,20.231c0,11.168-4.775,20.07-15.7,20.07s-15.86-8.9-15.86-20.07M88.946,42.239c8.255,0,11.087-6.718,11.087-15.7S97.2,9.708,88.946,9.708s-10.761,7.85-10.761,16.831,2.507,15.7,10.761,15.7"
        transform="translate(101.061 8.024)"
        fill="#fff"
      />
      <path
        id="Pfad_2"
        data-name="Pfad 2"
        d="M107.927,51.989a23.674,23.674,0,0,1-4.126.323c-10.036,0-10.2-6.554-10.2-9.468V16.787h-6.15V12.9H93.6V4l4.045-2.671V12.9h10.279v3.884H97.648V41.145c0,2.59,0,7.284,6.314,7.284a9.382,9.382,0,0,0,3.964-.73Z"
        transform="translate(120.528 1.835)"
        fill="#fff"
      />
      <path
        id="Pfad_3"
        data-name="Pfad 3"
        d="M123.5,45.15a35.924,35.924,0,0,1-8.412.973c-11.817,0-18.291-7.689-18.291-21.2,0-12.7,5.258-19.1,14.645-19.1,9.47,0,12.871,7.365,12.871,13.839v2.021H101.733c-.078,1.377-.078,2.671-.078,3.967,0,2.911.078,16.588,14.807,16.588a25.076,25.076,0,0,0,7.039-1.051ZM119.458,17.8c0-2.347-1.62-8.093-8.093-8.093-7.123,0-8.659,5.584-9.147,8.093Z"
        transform="translate(133.408 8.024)"
        fill="#fff"
      />
      <path
        id="Pfad_4"
        data-name="Pfad 4"
        d="M110.1,26.053c0-11.249,4.937-20.231,15.86-20.231s15.7,8.982,15.7,20.231c0,11.168-4.775,20.07-15.7,20.07s-15.86-8.9-15.86-20.07m15.618,16.186c8.255,0,11.087-6.718,11.087-15.7S133.972,9.708,125.718,9.708s-10.761,7.85-10.761,16.831,2.507,15.7,10.761,15.7"
        transform="translate(151.74 8.024)"
        fill="#fff"
      />
      <path
        id="Pfad_5"
        data-name="Pfad 5"
        d="M22.65,14.862c-.975-.488-4.628-2.6-8.6-2.6-2.763,0-6.01,1.3-6.01,3.57C8.036,20.948,25,23.545,25,34.589,25,42.544,18.914,46.2,10.393,46.2A31.282,31.282,0,0,1,.162,44.656v-7.8a25.291,25.291,0,0,0,9.822,2.354c2.193,0,6.659-.4,6.659-3.491C16.643,31.179,0,27.364,0,17.133,0,9.91,5.52,5.77,13.879,5.77A32.238,32.238,0,0,1,22.65,7.23Z"
        transform="translate(0 7.953)"
        fill="#fff"
      />
      <path
        id="Pfad_6"
        data-name="Pfad 6"
        d="M12.4,6.659h9.013v5.36h.162c.892-2.193,4.706-6.25,9.579-6.25,10.31,0,13.313,9.415,13.313,20.212,0,11.2-3.976,20.215-13.313,20.215a10.9,10.9,0,0,1-9.579-5.522h-.162V62.714H12.4ZM28.147,39.215c6.01,0,6.74-6.818,6.74-13.232,0-6.091-.973-13.235-6.74-13.235-4.951,0-6.735,7.144-6.735,13.235,0,7.144,1.622,13.232,6.735,13.232"
        transform="translate(17.088 7.953)"
        fill="#fff"
      />
      <path
        id="Pfad_7"
        data-name="Pfad 7"
        d="M28.087.105H37.1v8.93H28.087Zm0,14.362H37.1V53.11H28.087Z"
        transform="translate(38.71 0.145)"
        fill="#fff"
      />
      <path
        id="Pfad_8"
        data-name="Pfad 8"
        d="M58.322,53.5a45.325,45.325,0,0,1-7.389.649c-10.229,0-11.851-4.873-11.851-10.635V20.866H34.01V14.612h5.073V5.439L48.091,0V14.612h9.156v6.255H48.091V39.129c0,4.63.568,8.688,6.091,8.688a16.935,16.935,0,0,0,4.14-.649Z"
        transform="translate(46.873 0)"
        fill="#fff"
      />
      <path
        id="Pfad_9"
        data-name="Pfad 9"
        d="M68.428,53.5a45.325,45.325,0,0,1-7.389.649c-10.229,0-11.851-4.873-11.851-10.635V20.866H44.57V14.612h4.618V5.439L58.2,0V14.612H68.228v6.255H58.2V39.129c0,4.63.568,8.688,6.091,8.688a16.935,16.935,0,0,0,4.14-.649Z"
        transform="translate(61.427 0)"
        fill="#fff"
      />
      <path
        id="Pfad_10"
        data-name="Pfad 10"
        d="M77.074,40.84h-.162C75.7,43.357,73.015,46.2,66.846,46.2c-6.495,0-11.368-3.9-11.368-10.148,0-12.828,16.238-12.909,21.6-13.071V19.165c0-3.817-.975-7.066-5.439-7.066-4.954,0-5.927,3.329-5.927,5.929H56.938c0-7.389,4.873-12.26,14.7-12.26,9.579,0,14.046,4.143,14.046,12.015V45.3H77.074Zm-8.036-.975c5.843,0,8.036-6.333,8.036-11.608-5.846,0-12.826,1.784-12.826,6.98,0,3.006,1.7,4.628,4.79,4.628"
        transform="translate(76.46 7.951)"
        fill="#fff"
      />
    </g>
  </svg>
</template>
